export default __webpack_public_path__ + "static/media/hollard.98ca8495.jpg";